import { useState } from 'react';
import { QrCode, Download, Printer } from 'lucide-react';
import { Button } from '../../components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

export default function QRCodeMenu() {
  const [size, setSize] = useState(400);
  const qrUrl = `${API}/api/site/qrcode/menu?size=${size}`;

  const download = () => {
    const a = document.createElement('a');
    a.href = qrUrl;
    a.download = 'qrcode-menu-lemas.png';
    a.click();
  };

  const print = () => {
    const w = window.open('', '_blank');
    w.document.write(`
      <html><head><title>QR Code - Le Mas</title>
      <style>
        body { display:flex; flex-direction:column; align-items:center; justify-content:center; height:100vh; margin:0; font-family:sans-serif; }
        img { max-width:80vmin; }
        p { margin-top:16px; font-size:12px; color:#666; letter-spacing:2px; text-transform:uppercase; }
        @media print { p.noprint { display:none; } }
      </style></head>
      <body>
        <img src="${qrUrl}" alt="QR Code Menu Le Mas" />
        <p>Scannez pour voir notre carte</p>
        <p class="noprint" style="cursor:pointer" onclick="window.print()">Cliquez pour imprimer</p>
      </body></html>
    `);
  };

  return (
    <div className="space-y-6" data-testid="qrcode-page">
      <div className="flex items-center gap-3">
        <QrCode size={18} className="text-[rgb(var(--lm-gold))]" />
        <h1 className="text-lg font-title text-[rgb(var(--lm-text))]">QR Code Menu</h1>
      </div>

      <div className="lm-card p-6">
        <div className="flex flex-col md:flex-row gap-8 items-center">
          {/* QR Preview */}
          <div className="flex flex-col items-center gap-4">
            <div className="p-6 bg-white rounded-xl shadow-sm border border-gray-100" data-testid="qr-preview">
              <img src={qrUrl} alt="QR Code Menu" className="w-56 h-56" />
            </div>
            <p className="text-[10px] text-[rgb(var(--lm-text-muted))] uppercase tracking-wider">Scannez pour voir la carte</p>
          </div>

          {/* Info + Actions */}
          <div className="flex-1 space-y-4">
            <div>
              <h2 className="text-sm font-medium text-[rgb(var(--lm-text))] mb-1">QR Code de la Carte</h2>
              <p className="text-xs text-[rgb(var(--lm-text-muted))]">
                Imprimez ce QR code et placez-le sur vos cartes de restaurant.
                Les clients etrangers pourront scanner et choisir leur langue (FR, EN, ES, CA) directement sur le site.
              </p>
            </div>

            <div>
              <label className="text-[9px] text-[rgb(var(--lm-text-muted))] uppercase tracking-wider mb-1.5 block">Taille (px)</label>
              <div className="flex gap-1.5">
                {[200, 300, 400, 600, 800].map(s => (
                  <button key={s} onClick={() => setSize(s)}
                    className={`px-2.5 py-1.5 rounded-md text-[10px] font-medium transition-all border ${
                      size === s ? 'border-[rgb(var(--lm-gold))] text-[rgb(var(--lm-gold))] bg-[rgb(var(--lm-gold)/0.08)]' : 'border-[rgb(var(--lm-border))] text-[rgb(var(--lm-text-muted))]'
                    }`}
                    data-testid={`size-${s}`}>{s}</button>
                ))}
              </div>
            </div>

            <div className="flex gap-2 pt-2">
              <Button onClick={download} className="bg-[rgb(var(--lm-gold))] text-[rgb(var(--lm-bg))] hover:opacity-90 text-xs h-9" data-testid="download-qr">
                <Download size={13} className="mr-1.5" /> Telecharger PNG
              </Button>
              <Button variant="outline" onClick={print} className="text-xs h-9 border-[rgb(var(--lm-border))] text-[rgb(var(--lm-text-secondary))]" data-testid="print-qr">
                <Printer size={13} className="mr-1.5" /> Imprimer
              </Button>
            </div>

            <div className="p-2.5 rounded-lg bg-[rgb(var(--lm-gold)/0.06)] border border-[rgb(var(--lm-gold)/0.15)] mt-3">
              <p className="text-[10px] text-[rgb(var(--lm-gold))]">
                Conseil : imprimez en 300px minimum pour une bonne lisibilite. Le QR code pointe vers votre carte en ligne avec le selecteur de langue integre.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
